<template>
    <div :class="$style['product-css']" v-if="product != null">
        <div style="width: 100%; height: auto; position: relative">
            <div :class="$style['banner-top']">
                <img :src="product.product_poster"/>
            </div>
            <i role="button" v-ripple @click="likeProduct" :class="[(product.stat != null && product.stat.record_favorite != null && product.stat.record_favorite
            ? 'mdi mdi-heart' : 'mdi mdi-heart-outline'), $style['fave-button']]"></i>
        </div>
        <div style="background-color: #f7f5f5; padding: 4px 12px 4px 12px;">
            <h4 style=" font-weight: normal !important;" class="multi-line mt-3">
                {{product.product_title}}
            </h4>
            <h5 style="margin-top: 15px; margin-bottom: 10px; font-size: 14px !important; color: #9a9696; font-weight: normal !important;"
                class="multi-line font-weight-medium">{{product.product_description}}</h5>
        </div>
        <div style=" padding: 10px 12px 4px 12px; display: flex; justify-content: space-between">
            <div style="width: 50%">
                <span>قیمت محصول:</span>
                <p style="font-size: 20px; color: #7dc353"> {{oracle.format(product.product_sell_price)}} تومان</p>
            </div>
            <div style="width: 50%; text-align: left">
                <img style="width: 70%; height: auto" :src="product.product_cover"/>
            </div>
        </div>
        <div style="height: 100px"></div>
    </div>
</template>
<script>
    import oracle from "@/utils/oracle";

    export default {
        name: "ProductInfo",
        data() {
            return {
                id: null,
                oracle: oracle,
                product: null,
            };
        },
        methods: {
            getProduct() {
                oracle.axios(
                    "product/getOne",
                    {"product_id": this.id},
                    (res) => {
                        this.product = res.data;
                    }
                );
            },
            likeProduct() {
                if (!oracle.getToken()) {
                    oracle.showMessage('برای اضافه کردن این محصول به لیست علاقه مندی میبایست وارد حساب کاربری خود شوید.', 'ثبت نام / ورود', () => {
                        this.$router.push('/profile')
                    })
                    return
                }
                oracle.axios(
                    "product/setFavorite",
                    {"product_id": this.id},
                    (res) => {
                        this.getProduct()
                    }
                );
            }
        },
        mounted() {
            this.id = this.$route.query.id
            this.getProduct()
        },
    };
</script>
<style module>
    .product-css {
        height: 100%;
        overflow: scroll;
    }

    .product-css a {
        text-decoration: none;
    }

    .product-css .banner-top {
        width: 100% !important;
        height: calc(9 / 16 * 100vw);
        border-radius: 10px;
        overflow: hidden;
    }

    .product-css .fave-button {
        color: #7dc353;
        z-index: 1000;
        position: absolute;
        display: block;
        top: 10px;
        right: 0;
        left: 10px;
        text-align: left;
    }

    .product-css .banner-top img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
</style>
